import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomHttpParams } from '../api-handler/api-handler.service';
import { AppState } from '../../../store/state.model';
import { NgRedux } from '@angular-redux/store';
import { Guid } from 'guid-typescript';

/** This method intercepts the http request and set the headers required by Account management*/
@Injectable()
export class HeaderInterceptorService implements HttpInterceptor {
  /**
   * has a dependency on domain matcher to generate a dynamic X-channel
   * DomainMatcher
   **/
  constructor(public ngRedux: NgRedux<AppState>) {}

  /**
   * @event intercept Intercept any request that is triggered by APIHandler and sets the common header of the ORCH layer
   * @args domainMatcher
   * @returns The response that is being intercepted so it can continue to the Network call
   **/
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let headers = {};
    if (req.params instanceof CustomHttpParams && req.params.spec) {
      headers = this.getHeaders(req.params.spec);
    }
    return next.handle(
      req.clone({
        setHeaders: headers,
      })
    );
  }
  /**
   * getHeaders Return the common headers on the request
   **/
  public getHeaders(type): object {
    return {
      'x-correlationid': Guid.create().toString(),
      'x-channel': 'OP_ADMIN',
    };
  }
}
